import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from './services/auth.service';
import { ApplicationInsightsService } from './services/app-insights-service/app-insights.service';

@Component({
    selector: 'prof-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: false
})
export class AppComponent implements OnInit {
  browserLang: string;
  title = 'prof';

  constructor(
    private _translate: TranslateService,
    private auth: AuthService,
    private appInsightsService: ApplicationInsightsService
  ) {
    _translate.addLangs(['en', 'es', 'fr', 'it', 'zh']);
    _translate.setDefaultLang('en');
    this.browserLang = _translate.getBrowserLang();
    _translate.use(
      this.browserLang.match(/en|es|fr|it|zh/) ? this.browserLang : 'en'
    );
  }

  ngOnInit() {
    this.auth.localAuthSetup();
    this.auth.handleAuthCallback();
  }
}
